// extracted by mini-css-extract-plugin
module.exports = {"input":"inputControl_input__Oq3A_","monospace":"inputControl_monospace__QgUXw","readOnly":"inputControl_readOnly__10Y-h","disabled":"inputControl_disabled__3WwJi"};